import { render, staticRenderFns } from "./DataBaseHome.vue?vue&type=template&id=04758c8c&"
import script from "./DataBaseHome.vue?vue&type=script&lang=js&"
export * from "./DataBaseHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports